import React from "react";
import * as yup from "yup";
import {useHistory} from "react-router-dom";
import {Form, Formik} from "formik";
import {CircularProgress, Grid, IconButton, makeStyles} from "@material-ui/core";
import clsx from "clsx";
import {FormikTextField} from "../form/FormikTextField";
import {FormikSelect} from "../form/FormikSelect";
import {RedCloseIcon} from "./RedCloseIcon";
import {GreenCheckIcon} from "./GreenCheckIcon";

const useStyles = makeStyles(theme => ({
    spacing: {
        marginRight: theme.spacing(1)
    },
    container: {
        display: 'flex',
        alignItems: 'center'
    },
    select: {
        width: 100
    }
}));

const validationSchema = yup.object({
    salutation: yup.string().required('erforderlich'),
    firstName: yup.string().required('erforderlich'),
    lastName: yup.string().required('erforderlich')
});

export interface NameDto {
    firstName: string;
    lastName: string;
    salutation: string;
}

export interface EditNameFormProps {
    initialValues: NameDto;
    className?: string;
    onSubmit: (dto: NameDto) => Promise<any>;
}

export function EditNameForm({initialValues, className, onSubmit}: EditNameFormProps) {
    const classes = useStyles();
    const history = useHistory();

    const [isLoading, setIsLoading] = React.useState(false);

    const closeForm = () => history.replace({search: undefined});

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
                setIsLoading(true);
                onSubmit(values)
                    .catch(() => {
                    })
                    .finally(() => {
                        setIsLoading(false);
                        closeForm();
                    })
            }}
            validationSchema={validationSchema}
        >
            {({submitForm}) => (
                <Form className={clsx(className, classes.container)}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <FormikSelect
                                name={"salutation"}
                                label="Anrede"
                                required
                                options={[
                                    {value: 'Herr', label: 'Herr'},
                                    {value: 'Frau', label: 'Frau'},
                                    {value: 'Divers', label: 'Divers'},
                                ]}
                                className={clsx(classes.spacing, classes.select)}
                            />
                        </Grid>
                        <Grid item xs={4} md={3}>
                            <FormikTextField
                                name={"firstName"}
                                label="Vorname"
                                className={classes.spacing}
                            />
                        </Grid>
                        <Grid item xs={4} md={3}>
                            <FormikTextField
                                name={"lastName"}
                                label="Nachname"/>
                        </Grid>
                        <Grid item xs={4} md={3}>
                            {isLoading
                                ? <CircularProgress size={20} color="secondary"/>
                                : (
                                    <>
                                        <IconButton edge="end" onClick={closeForm}>
                                            <RedCloseIcon/>
                                        </IconButton>
                                        <IconButton edge="end" onClick={submitForm}>
                                            <GreenCheckIcon/>
                                        </IconButton>
                                    </>
                                )
                            }
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    )
}
